import { Link } from "react-router-dom";

export function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div
      className="min-h-screen relative flex items-center justify-center px-4 py-12"
      style={{
        backgroundImage:
          "linear-gradient(180deg, rgba(12,10,9,0.8) 0%, rgba(12,10,9,0.95) 100%), url(/generated/hero_landing.png)",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
      data-testid="auth-shell"
    >
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <Link to="/" className="inline-flex flex-col items-center gap-2" data-testid="brand-link">
            <img src="/apple-touch-icon.png" alt="Territoria: Life" className="w-20 h-20 rounded-xl shadow-[0_0_24px_rgba(180,140,60,0.35)]" />
            <span className="font-display text-3xl heading-gilded">Territoria: Life</span>
          </Link>
          <p className="mt-1 text-stone-500 uppercase tracking-[0.3em] font-numeric text-[10px]">
            Chapter of Beginnings
          </p>
        </div>

        <div className="panel p-8">
          <h1 className="font-display text-3xl mb-1">{title}</h1>
          {subtitle && (
            <p className="text-stone-400 font-body mb-6">{subtitle}</p>
          )}
          {children}
        </div>

        {footer && (
          <div className="text-center mt-6 text-stone-400 text-sm font-body">
            {footer}
          </div>
        )}
      </div>
    </div>
  );
}
